import { z } from 'src/lib'
import { OperacionAFOPUFields, OperacionAFOPUTablaValorFields } from './fields'
import { schemaEntityWithId } from 'src/types'

export const schemaFormOperacionAFOPUTablaValor = z.object({
    [OperacionAFOPUTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOPUTablaValorFields.DescInstrumento]: z.string(),
    [OperacionAFOPUTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOPUTablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionAFOPUTablaValorFields.Valor]: z
        .string({ 
            invalid_type_error: 'El aforo es requerido',
            required_error: 'El aforo es requerido'
        })
        .nullable()
        .refine(val => val !== null && val !== '', { 
            message: 'El aforo es requerido' 
        }),
    [OperacionAFOPUTablaValorFields.OrdenInstrumento]: z.number(),
});

export type FormOperacionAFOPUTablaValor = z.infer<typeof schemaFormOperacionAFOPUTablaValor>;

export const schemaFormOperacionAFOPU = z
    .object({
        [OperacionAFOPUFields.CodPais]: z.number({ required_error: 'El país es requerido.' }),
        [OperacionAFOPUFields.CodUnidadNegocio]: z.number({ required_error: 'La unidad de negocio es requerida.' }),
        [OperacionAFOPUFields.CodSectorComercial]: z.coerce.number({ invalid_type_error: 'El sector comercial es requerido.' }).min(1, { message: 'El sector comercial es requerido.' }),
        [OperacionAFOPUFields.FechaSolicitud]: z.date({ required_error: 'La fecha de solicitud es requerida.' }),
        [OperacionAFOPUFields.FechaVencimiento]: z.date({ required_error: 'La fecha de vencimiento es requerida.' }),
        [OperacionAFOPUFields.Observaciones]: z.string().optional().nullable(),
        [OperacionAFOPUFields.TablaValores]: z.array(schemaFormOperacionAFOPUTablaValor)
            .min(1, { message: 'Debe completar los aforos.' }),
    })
    .refine(
        (schema) => {
            if (schema.fechaVencimiento && schema.fechaSolicitud) {
                return schema.fechaVencimiento.getTime() >= schema.fechaSolicitud.getTime();
            }
            
            return true;
        },
        {
            message: 'La fecha de vencimiento debe ser mayor o igual a la fecha de solicitud.',
            path: [OperacionAFOPUFields.FechaVencimiento],
        }
    );

export type FormOperacionAFOPU = z.infer<typeof schemaFormOperacionAFOPU>

export const schemaOperacionAFOPU = z
    .object({
        [OperacionAFOPUFields.CodOperacionAFOPU]: z.number(),
        [OperacionAFOPUFields.CodPais]: z.number(),
        [OperacionAFOPUFields.NombrePais]: z.string(),
        [OperacionAFOPUFields.CodUnidadNegocio]: z.number().nullable(),
        [OperacionAFOPUFields.DescUnidadNegocio]: z.string().nullable(),
        [OperacionAFOPUFields.CodSectorComercial]: z.number(),
        [OperacionAFOPUFields.DescSectorComercial]: z.string(),
        [OperacionAFOPUFields.FechaSolicitud]: z.coerce.date(),
        [OperacionAFOPUFields.FechaVencimiento]: z.coerce.date(),
        [OperacionAFOPUFields.CodEstado]: z.number(),
        [OperacionAFOPUFields.DescEstado]: z.string(),
        [OperacionAFOPUFields.FechaAprobacion]: z.coerce.date().nullable(),
        [OperacionAFOPUFields.FechaAlta]: z.coerce.date().nullable(),
        [OperacionAFOPUFields.IdUsuarioAlta]: z.number(),
        [OperacionAFOPUFields.NombreUsuarioAlta]: z.string(),
        [OperacionAFOPUFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionAFOPUFields.Observaciones]: z.string().nullable(),
        [OperacionAFOPUFields.EstadoFinalizado]: z.boolean(),
        [OperacionAFOPUFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionAFOPUFields.PermiteEliminarOperacion]: z.boolean(),
    })
    .merge(schemaEntityWithId)

export type OperacionAFOPU = z.infer<typeof schemaOperacionAFOPU>